import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { ProfileProps } from './profile.component'

export const ProfileType = ComponentTypeFactory.create<ProfileProps>(
  'Profile',
  {
    navigation: FieldTypeFactory.list({
      of: {
        isEnabled: FieldTypeFactory.boolean({ defaultValue: true }),
        url: FieldTypeFactory.text(),
        label: FieldTypeFactory.text(),
      },
    }),
    isDev: FieldTypeFactory.boolean({ required: false }),
    profileLabels: {
      general: {
        myProfile: FieldTypeFactory.text(),
        backToShop: FieldTypeFactory.text(),
      },
      personalInfo: {
        title: FieldTypeFactory.text(),
        requiredFieldsTitle: FieldTypeFactory.text(),
        requiredFieldsLabels: {
          requiredSign: FieldTypeFactory.text(),
          firstName: FieldTypeFactory.text(),
          lastName: FieldTypeFactory.text(),
          email: FieldTypeFactory.text(),
        },
        otherLabels: {
          gender: FieldTypeFactory.text(),
          pass: FieldTypeFactory.text(),
          passPlaceholder: FieldTypeFactory.text(),
          edit: FieldTypeFactory.text(),
          datePlaceholder: FieldTypeFactory.text(),
          dob: FieldTypeFactory.text(),
        },
      },
      orderHistoryLabels: {
        orderRefNumber: FieldTypeFactory.text(),
        orderStatus: FieldTypeFactory.text(),
        send: FieldTypeFactory.text(),
        details: FieldTypeFactory.text(),
        nr: FieldTypeFactory.text(),
        quantity: FieldTypeFactory.text(),
        numberOfProducts: FieldTypeFactory.text(),
        products: FieldTypeFactory.text(),
        price: FieldTypeFactory.text(),
        discount: FieldTypeFactory.text(),
        delivery: FieldTypeFactory.text(),
        total: FieldTypeFactory.text(),
        fastDelivery: FieldTypeFactory.text(),
        deliveryConditions: FieldTypeFactory.text(),
        deliveryStatus: {
          Draft: FieldTypeFactory.text(),
          Open: FieldTypeFactory.text(),
          Confirmed: FieldTypeFactory.text(),
          Complete: FieldTypeFactory.text(),
          Cancelled: FieldTypeFactory.text(),
        },
        free: FieldTypeFactory.text(),
      },
      wallet: {
        shops: FieldTypeFactory.list({
          of: {
            name: FieldTypeFactory.text(),
          },
        }),
        labels: {
          cardInfo: {
            image: FieldTypeFactory.image(),
            titleActive: FieldTypeFactory.text(),
            titleRequested: FieldTypeFactory.text(),
            discount1: FieldTypeFactory.text(),
            discount2: FieldTypeFactory.text(),
          },
          requestWallet: {
            callToAction: FieldTypeFactory.text(),
            names: FieldTypeFactory.text(),
            phone: FieldTypeFactory.text(),
            email: FieldTypeFactory.text(),
            gender: FieldTypeFactory.text(),
            dateOfBirth: FieldTypeFactory.text(),
            numberOfChildren: FieldTypeFactory.text(),
            country: FieldTypeFactory.text(),
            city: FieldTypeFactory.text(),
            postalCode: FieldTypeFactory.text(),
            shop: FieldTypeFactory.text(),
            gdprConsent: FieldTypeFactory.text(),
            mandatoryFieldsTitle: FieldTypeFactory.text(),
            cardholderDataTitle: FieldTypeFactory.text(),
            cardholderAddresTitle: FieldTypeFactory.text(),
            orderCardCallToAction: FieldTypeFactory.text(),
          },
          activateWallet: {
            callToAction: FieldTypeFactory.text(),
            activateWalletTitle: FieldTypeFactory.text(),
            cardNumber: FieldTypeFactory.text(),
            activateBtn: FieldTypeFactory.text(),
          },
        },
      },
      updatePassword: {
        current: FieldTypeFactory.text(),
        newPass: FieldTypeFactory.text(),
        repeatPassword: FieldTypeFactory.text(),
        save: FieldTypeFactory.text(),
        validations: {
          newPassMustBeDifferent: FieldTypeFactory.text(),
          passwordsDoNotMatch: FieldTypeFactory.text(),
          somethingWentWrong: FieldTypeFactory.text(),
          mandatoryField: FieldTypeFactory.text(),
          passMustBeLonger: FieldTypeFactory.text(),
          passChangeSuccess: FieldTypeFactory.text(),
        },
      },
      accountSettings: {
        unspecified: FieldTypeFactory.text(),
        male: FieldTypeFactory.text(),
        female: FieldTypeFactory.text(),
        monthOptions: FieldTypeFactory.list({
          of: {
            value: FieldTypeFactory.number(),
            label: FieldTypeFactory.text(),
          },
        }),
      },
      gdpr: {
        title: FieldTypeFactory.text(),
        actionTitle: FieldTypeFactory.text(),
        description: FieldTypeFactory.text(),
        awaitingAnonymizationApproval: FieldTypeFactory.text(),
        actions: FieldTypeFactory.list({
          of: {
            url: FieldTypeFactory.text(),
            label: FieldTypeFactory.text(),
          },
        }),
        tables: FieldTypeFactory.list({
          of: {
            title: FieldTypeFactory.text(),
            content: FieldTypeFactory.text(),
            links: FieldTypeFactory.list({
              of: {
                url: FieldTypeFactory.text(),
                label: FieldTypeFactory.text(),
              },
            }),
          },
        }),
      },
    },
  }
)
